<template>
    <Layout>
        <DocumentHeader :type="type" :device="device"></DocumentHeader>
        <DocumentBody :type="type" :device="device"></DocumentBody>
    </Layout>
</template>

<script>
	import {mapState} from "vuex";
	import DocumentHeader from "./DocumentHeader.vue";
	import DocumentBody from "./DocumentBody.vue";

	export default {
		name: "DocumentBasic",
		props: {
			type: String,
			device: String
		},
		components: {
			DocumentHeader,
			DocumentBody
		},
		computed: {
			...mapState({
				versions: state => state.document.versions
			})
		},
		created() {
			this.$store.dispatch("document/setType", this.type);
			this.$store.dispatch("document/setDevice", this.device);
			this.$store.dispatch("document/getVersions");
		}
	};
</script>

<style>
</style>
